<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label class="text-info" v-if="label" :for="name">{{ label }}</label>
    <input type="text"
           v-mask="'99/99/9999'"
           :value="value || false"
           @input="updateValue($event.target.value)"
           @blur="handleBlur($event.target.value)"
           @change="updateValue($event.target.value)"
		   @focus="$emit('emitFocus')"
           :name="name"
           :required="required"
           :placeholder="placeholder"
           class="form-control datetimepicker"
           :class="additionalClass"
    >
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputDate',
    props: ['name', 'value', 'minDate', 'maxDate', 'minPeriod', 'sundayDisabled', 'required', 'label', 'placeholder', 'error', 'additionalClass'],
    components: {},
    data () {
      return {}
    },
    mounted () {
      let self = this
      let config = {
        format: 'DD/MM/YYYY'
      }
      if (this.maxDate === 'today') {
        config.maxDate = window.moment()
      }
      switch (this.minDate) {
        case 'today':
          config.minDate = window.moment()
          break
        case 'yesterday':
          config.minDate = window.moment().subtract(1, 'd')
          break
        case 'tomorrow':
          config.minDate = window.moment().add(1, 'd')
          break
        default:
          if (this.minDate) {
            config.minDate = window.moment(this.minDate, 'DD/MM/YYYY')
          }
      }
      if (config.minDate) {
        if (config.minDate.weekday() === 7) {
          config.minDate = config.minDate.add(1, 'd')
        }
        if (config.minDate.weekday() === 6) {
          config.minDate = config.minDate.add(2, 'd')
        }
      }
      if (config.maxDate) {
        if (config.maxDate.weekday() === 7) {
          config.maxDate = config.maxDate.add(1, 'd')
        }
        if (config.maxDate.weekday() === 6) {
          config.maxDate = config.maxDate.add(2, 'd')
        }
      }

      if (this.sundayDisabled) {
        config.daysOfWeekDisabled = [0]
      }
      window.$('.datetimepicker', this.$el)
      .datetimepicker(config)
      .on('dp.change', (e) => {
        self.updateValue(window.moment(e.date).format('DD/MM/YYYY'))
      })
      this.updateValue(window.$('.datetimepicker', this.$el)[0].value)
    },
    methods: {
      handleBlur (value) {
        this.$emit('emitBlur')
        this.updateValue(value)
      },
      updateValue (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InputDate.vue?9ccd242e